import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Select from 'react-select';
import {  getSingleWalletValidity, updateOneWalletValidity } from '../../../redux/wallet/action';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Col } from 'reactstrap';
import { usePermissions } from '../../../Hooks/usePermissions';
import { MENU, PERMISSION } from '../../../lib/permissions';

const durationTypeOptions = [
  { value: '1', label: 'Unlimited' },
  { value: '2', label: 'Days' },
  { value: '3', label: 'Weeks' },
  { value: '4', label: 'Months' },
  { value: '5', label: 'Years' }
];

const statusOptions = [
  { value: '1', label: 'Active' },
  { value: '0', label: 'Inactive' }
];

const validationSchema = Yup.object().shape({
  duration_type: Yup.string().required('Duration type is required'),
  duration: Yup.number()
    .nullable()
    .transform((value, originalValue) =>
      String(originalValue).trim() === '' ? null : value
    )
    .when('duration_type', {
      is: (val) => val !== '1',
      then: (schema) =>
        schema
          .typeError('Duration must be a number')
          .positive('Duration must be greater than 0')
          .required('Duration is required'),
      otherwise: (schema) => schema.notRequired()
    }),
  status: Yup.string().required('Status is required')
});

const UpdateWalletValidities = () => {
  const { id } = useParams();
  const walletList = useSelector((state) => state.reusableSlice.SingleWalletValidity);

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { hasAction } = usePermissions();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      duration_type: walletList?.duration_type?.toString() || '',
      duration: walletList?.duration || '',
      status: walletList?.status?.toString() || '1'
    },
    validationSchema,
    onSubmit: (values) => handleSubmit(values)
  });

  const handleSubmit = (values) => {
    const data = {
      ...values,
      id : id,
      duration: values.duration_type === '1' ? 0 : values.duration
    };
    dispatch(updateOneWalletValidity(data, setLoading, navigate));
  };

  useEffect(() => {
    if (id) {
      dispatch(getSingleWalletValidity(id));
    }
  }, [dispatch, id]);


  // permisision check

  const isEditable = hasAction(MENU.CATALOGUE, PERMISSION.EDIT);

  console.log(formik.values,"formik")
  
  return (
    <div className="card-head p-4 order-card order-timing">
      <form onSubmit={formik.handleSubmit}>

        {/* Duration Type */}
        <div className="mb-3">
          <label className="form-label">Duration Type</label>
          <Select
          isDisabled={!isEditable}
            options={durationTypeOptions}
            value={durationTypeOptions.find(option => option.value === formik.values.duration_type)}
            onChange={selected => formik.setFieldValue('duration_type', selected.value)}
            onBlur={() => formik.setFieldTouched('duration_type', true)}
            placeholder="Select Duration Type"
          />
          {formik.touched.duration_type && formik.errors.duration_type && (
            <div className="text-danger">{formik.errors.duration_type}</div>
          )}
        </div>

        {/* Duration */}
        <div className="mb-3">
          <label htmlFor="duration" className="form-label">Duration</label>
          <input
            type="number"
            id="duration"
            name="duration"
            className="form-control"
            value={formik.values.duration}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            disabled={!isEditable || formik.values.duration_type === '1'}
            min="1"
          />
          {formik.touched.duration && formik.errors.duration && (
            <div className="text-danger">{formik.errors.duration}</div>
          )}
        </div>

        {/* Status */}
        <div className="mb-3">
          <label className="form-label">Status</label>
          <Select
            isDisabled={!isEditable}
            options={statusOptions}
            value={statusOptions.find(option => option.value === formik.values.status)}
            onChange={selected => formik.setFieldValue('status', selected.value)}
            onBlur={() => formik.setFieldTouched('status', true)}
            placeholder="Select Status"
          />
          {formik.touched.status && formik.errors.status && (
            <div className="text-danger">{formik.errors.status}</div>
          )}
        </div>
        <Col
                          className="text-center back-update justify-content-between p-0"
                          xs={12}
                        >
                           <button
                    className="back-btn"
                    disabled={loading}
                    onClick={() => navigate("/wallet/validities/list")}
                    type="button"
                  >
                    Back
                  </button>
       { isEditable && (
                   <button type="submit" className="submit-btn" disabled={loading}>
          {loading ? 'Submitting...' : 'Submit'}
        </button>
                  )}
                          </Col>

      </form>
    </div>
  );
};

export default UpdateWalletValidities;
